import {Component, OnInit} from '@angular/core';
import {RolesService} from '../../../core/services/roles/roles.service';
import {TranslateModule} from '@ngx-translate/core';
import {LoadingComponent} from '../../../shared/components/loading/loading.component';
import {CommonModule} from '@angular/common';
import {RoleModel} from '../../../core/models/roles/role.model';

@Component({
  selector: 'app-roles-list',
  imports: [
    TranslateModule,
    LoadingComponent,
    CommonModule
  ],
  templateUrl: './roles-list.component.html',
  styleUrl: './roles-list.component.scss'
})
export class RolesListComponent implements OnInit {

  loading: boolean = false;
  roles: RoleModel[] = [];

  constructor(private readonly roleService: RolesService) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.roleService.getRoles().subscribe({
      next: (roles) => {
        this.roles = roles;
        this.loading = false;
      },
      error: (err) => {
        console.error(err);
        this.loading = false;
      }
    });
  }
}
